window.$ = window.jQuery = require("jquery");

require("../sass/style.scss");

require('./vendor/slick.js');
require('./vendor/limarquee.js');

$(function () {

    // Sticky header 
    function stickyHeader() {
        if ($(window).scrollTop() > 80) {
            $('header.header').addClass('fixed');
        } else {
            $('header.header').removeClass('fixed');
        }
    }
    stickyHeader();
    $(window).scroll(function () {
        stickyHeader();
    }); 

    $(document).on('click', '.hamburger-menu', function (e) {
        $(this).toggleClass('open');
        $('#responsive-menu').toggleClass('open');
    });

    /*
    if ($('.section-clients-slider .client-slider').length) {
        $('.section-clients-slider .client-slider').slick({
            speed: 9000,
            autoplay: true,
            arrows: false,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 5,
            slidesToScroll: 1, 
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3, 
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2, 
                  }
                },
                {
                  breakpoint: 550,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1, 
                  }
                }
            ]
        });
    }
    */

    if ($('.section-screen-slider ').length) {
        $('.section-screen-slider .slider-screen').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false, 
            asNavFor: '.slider-title, .slider-list',
            autoplay: true,
            autoplaySpeed: 5000,
        });
        $('.section-screen-slider .slider-title').slick({
            slidesToShow: 10,
            slidesToScroll: 1,
            asNavFor: '.slider-screen, .slider-list',
            dots: false, 
            focusOnSelect: true,
            vertical: true
        });
        $('.section-screen-slider .slider-list').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-title, .slider-screen'
        });
    }

    if ($('.section-team-slider').length) {
        $('.section-team-slider .team-slider').slick({
            slidesToShow: 1,
            infinite: true,
            variableWidth: true,
            arrows: false, 
            autoplay: true,
            autoplaySpeed: 3000,
        });
    }

    // Scroll to Top 
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    }); 


    var page = 2;
    var perPage = $('#WPPerPage').val();
    // Blog Listing Ajax Pagination 
    $('#loadmoreanchor').click(function () {
        $('#loadmoreanchor .text').html('Loading posts. Please wait..');
        if (($('#categoryId').val())) {
            var load_url = '?paged=' + page + '&category=' + $('#categoryId').val();
        } else {
            var load_url = '?paged=' + page;
        }
        $('#postsLazyload').append($('<div class="blog-listing-wrap" id="post_section' + page + '">').load(load_url + ' .blog-listing-wrap > *', function () {
            page++;
            $('#loadmoreanchor .text').html('Load more');
            if ($('#WPTotalNumPages').val() < page) {
                $('.loadmoreanchor-wrap').css('display', 'none');
            }

        }));
    }); 
    $('.filter-button').click(function () {
        page = '';
        var currentCategory = $(this).attr('id');
        var load_url = '?paged=' + page + '&category=' + currentCategory;
        $('.loadmoreanchor-wrap').css('display', 'none');
        $('.post-filter-section a').removeClass('active');
        $(this).addClass('active');
        $('#categoryId').val(currentCategory);
        $(".blog-listing-wrap").remove();
        $('#postsLazyload').append('<div class="category-posts-loading">Loading... Please wait.</div>');
        $('#postsLazyload').append($('<div class="blog-listing-wrap" id="post_section' + page + '">').load(load_url + ' .blog-listing-wrap > *', function () {
            $('.category-posts-loading').remove();
            $('#WPTotalNumPages').val($('#post_section' + page + ' .WPTotalNumPages2').val());
            if ($('#post_section' + page + ' .WPTotalNumPages2').val() == 1) {
                return;
            }
            $('.loadmoreanchor-wrap').css('display', 'block'); 
            page = 1;
            page++;
        }));
    });



});

$(function () {

    // Slider Toogle
    var stTime = 12000,
    stBar = $('.slider-toggle-wrap #progress-bar-width');

    function slideToggleProgressBar() {
        stBar.clearQueue();
        stBar.stop();
        stBar.css('width', '0');
        setInterval(
            function () {
                stBar.animate({'width': "+=100%"}, stTime);
            },
            10);
    }
    
    if ($('.slider-toggle-wrap .slick-slider-toggle').length) {
        $('.slider-toggle-wrap .slick-slider-toggle').slick({
            autoplay: true,
            adaptiveHeight: true,
            vertical: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplaySpeed: stTime,
        });
        $(window).load(function () {
            $('.slider-toggle-wrap .slick-slider-toggle').slick('slickGoTo', 0);
        });
        $('.slider-toggle-wrap .slick-slider-toggle').on('afterChange', function (event, slick, currentSlide) {
            console.log(currentSlide + 'ac');
            $('.slider-toggle-wrap .slick-slider-toggle .slick-active[data-slick-index=' + currentSlide + ']').find('.content').slideDown(200);
            $('.slider-toggle-wrap .slick-slider-toggle').slick('resize');
            setTimeout(function () {
            }, 2000);
        });
        $('.slider-toggle-wrap .slick-slider-toggle').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            console.log(currentSlide + "bc");
            $('.slider-toggle-wrap .slick-slider-toggle .slick-active[data-slick-index=' + currentSlide + ']').find('.content').slideUp(200);
        });
    }


    if ($('.slider-toggle-wrap .st-slide').length <= 5) {
        var timeoutHandle = setInterval(slideToggleAutoPlay, stTime),
            totalSlideToggleItems = $('.slider-toggle-wrap .st-slide').length;
        slideToggleProgressBar();
        $(document).on('click', '.slider-toggle-wrap .st-slide', function (e) {
            if ($(this).hasClass('slick-current')) {
                return;
            } else {
                $('.st-slide.slick-current').removeClass('slick-current').find('.st-single .content').slideUp(600);
                $(this).addClass('slick-current').find('.st-single .content').slideDown(600);
            }
            clearInterval(timeoutHandle);
            timeoutHandle = null;
            timeoutHandle = setInterval(slideToggleAutoPlay, stTime);
            slideToggleProgressBar();
        });

        function slideToggleAutoPlay() {
            if ($(".slider-toggle-wrap .st-slide.slick-current").data('index') <= (totalSlideToggleItems - 1)) {
                $(".slider-toggle-wrap .st-slide.slick-current").next().trigger('click');
            } else {
                $('.slider-toggle-wrap .st-slide:first').trigger('click');
            }
        }

        function slideToggleAutoPlayPrev() {
            if ($(".slider-toggle-wrap .st-slide.slick-current").data('index') != 1) {
                $(".slider-toggle-wrap .st-slide.slick-current").prev().trigger('click');
            } else {
                $('.slider-toggle-wrap .st-slide:last').trigger('click');
            }
        }

        $(document).on('click', '.slider-toggle-wrap .st-next', function (e) {
            slideToggleAutoPlay();
        });
        $(document).on('click', '.slider-toggle-wrap .st-prev', function (e) {
            slideToggleAutoPlayPrev();
        });
    }

    // Slider Text Content 
    if ($('.slider-text-content .text-slider').length) {
        $('.slider-text-content .text-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplaySpeed: 6000,
            dots: false,
            autoplay: true,
            fade: true,
            cssEase: 'linear', 
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                    }
                }
            ]
        });
        $('.slider-text-content .text-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slider-text-content .slider-numbered-list-wrap .slider-number').removeClass('active');
            $('.slider-text-content .slider-numbered-list-wrap .slider-number[data-slide=' + nextSlide + ']').addClass('active');
        });
        $(document).on('click', '.slider-text-content .numbered-list .item', function (){
            $('.slider-text-content .numbered-list .item').removeClass('active');
            $(this).addClass('active');
            var slide_id = $(this).attr('data-slide');
            $('.slider-text-content .text-slider').slick('slickGoTo', slide_id);
        });
        $('.slider-text-content .text-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slider-text-content .numbered-list .item').removeClass('active');
            $('.slider-text-content .numbered-list .item[data-slide=' + nextSlide + ']').addClass('active');
        });
    }
});


$(window).on('load', function(){
    $('.brand-slider-section-type-1').liMarquee();    
    $(".brand-slider-section-type-1 .client-item img").hover(function () {
        var brandImageRight = $(window).width() - ($(this).offset().left + $(this).width());
        if(brandImageRight < 280){
            $(this).parent().addClass('show-hover-right');
        }
        $(this).parent().addClass('show-hover');
    }, function () {
        $(this).parent().removeClass('show-hover-right show-hover');
    });
})

$(document).ready(function () {
    my_browser_body_class();
});
function my_browser_body_class() {
    // jQBrowser v0.2: http://davecardwell.co.uk/javascript/jquery/plugins/jquery-browserdetect/
    eval(function (p, a, c, k, e, d) {
        e = function (c) {
            return (c < a ? "" : e(c / a)) + String.fromCharCode(c % a + 161)
        };
        while (c--) {
            if (k[c]) {
                p = p.replace(new RegExp(e(c), 'g'), k[c])
            }
        }
        return p
    }('Ö ¡(){® Ø={\'¥\':¡(){¢ £.¥},\'©\':{\'±\':¡(){¢ £.©.±},\'¯\':¡(){¢ £.©.¯}},\'¬\':¡(){¢ £.¬},\'¶\':¡(){¢ £.¶},\'º\':¡(){¢ £.º},\'Á\':¡(){¢ £.Á},\'À\':¡(){¢ £.À},\'½\':¡(){¢ £.½},\'¾\':¡(){¢ £.¾},\'¼\':¡(){¢ £.¼},\'·\':¡(){¢ £.·},\'Â\':¡(){¢ £.Â},\'³\':¡(){¢ £.³},\'Ä\':¡(){¢ £.Ä},\'Ã\':¡(){¢ £.Ã},\'Å\':¡(){¢ £.Å},\'¸\':¡(){¢ £.¸}};$.¥=Ø;® £={\'¥\':\'¿\',\'©\':{\'±\':²,\'¯\':\'¿\'},\'¬\':\'¿\',\'¶\':§,\'º\':§,\'Á\':§,\'À\':§,\'½\':§,\'¾\':§,\'¼\':§,\'·\':§,\'Â\':§,\'³\':§,\'Ä\':§,\'Ã\':§,\'Å\':§,\'¸\':§};Î(® i=0,«=».ì,°=».í,¦=[{\'¤\':\'Ý\',\'¥\':¡(){¢/Ù/.¨(°)}},{\'¤\':\'Ú\',\'¥\':¡(){¢ Û.³!=²}},{\'¤\':\'È\',\'¥\':¡(){¢/È/.¨(°)}},{\'¤\':\'Ü\',\'¥\':¡(){¢/Þ/.¨(°)}},{\'ª\':\'¶\',\'¤\':\'ß Ñ\',\'¥\':¡(){¢/à á â/.¨(«)},\'©\':¡(){¢ «.¹(/ã(\\d+(?:\\.\\d+)+)/)}},{\'¤\':\'Ì\',\'¥\':¡(){¢/Ì/.¨(«)}},{\'¤\':\'Í\',\'¥\':¡(){¢/Í/.¨(°)}},{\'¤\':\'Ï\',\'¥\':¡(){¢/Ï/.¨(«)}},{\'¤\':\'Ð\',\'¥\':¡(){¢/Ð/.¨(«)}},{\'ª\':\'·\',\'¤\':\'å Ñ\',\'¥\':¡(){¢/Ò/.¨(«)},\'©\':¡(){¢ «.¹(/Ò (\\d+(?:\\.\\d+)+(?:b\\d*)?)/)}},{\'¤\':\'Ó\',\'¥\':¡(){¢/æ|Ó/.¨(«)},\'©\':¡(){¢ «.¹(/è:(\\d+(?:\\.\\d+)+)/)}}];i<¦.Ë;i++){µ(¦[i].¥()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¥=¦[i].¤;® ­;µ(¦[i].©!=²&&(­=¦[i].©())){£.©.¯=­[1];£.©.±=Ê(­[1])}ê{® Ç=Ö ë(¦[i].¤+\'(?:\\\\s|\\\\/)(\\\\d+(?:\\\\.\\\\d+)+(?:(?:a|b)\\\\d*)?)\');­=«.¹(Ç);µ(­!=²){£.©.¯=­[1];£.©.±=Ê(­[1])}}×}};Î(® i=0,´=».ä,¦=[{\'ª\':\'¸\',\'¤\':\'ç\',\'¬\':¡(){¢/é/.¨(´)}},{\'¤\':\'Ô\',\'¬\':¡(){¢/Ô/.¨(´)}},{\'¤\':\'Æ\',\'¬\':¡(){¢/Æ/.¨(´)}}];i<¦.Ë;i++){µ(¦[i].¬()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¬=¦[i].¤;×}}}();', 77, 77, 'function|return|Private|name|browser|data|false|test|version|identifier|ua|OS|result|var|string|ve|number|undefined|opera|pl|if|aol|msie|win|match|camino|navigator|mozilla|icab|konqueror|Unknown|flock|firefox|netscape|linux|safari|mac|Linux|re|iCab|true|parseFloat|length|Flock|Camino|for|Firefox|Netscape|Explorer|MSIE|Mozilla|Mac|toLowerCase|new|break|Public|Apple|Opera|window|Konqueror|Safari|KDE|AOL|America|Online|Browser|rev|platform|Internet|Gecko|Windows|rv|Win|else|RegExp|userAgent|vendor'.split('|')))

    /* ----------------------------------------------------------------- */

    var aol = $.browser.aol();       // AOL Explorer
    var camino = $.browser.camino();    // Camino
    var firefox = $.browser.firefox();   // Firefox
    var flock = $.browser.flock();     // Flock
    var icab = $.browser.icab();      // iCab
    var konqueror = $.browser.konqueror(); // Konqueror
    var mozilla = $.browser.mozilla();   // Mozilla
    var msie = $.browser.msie();      // Internet Explorer Win / Mac
    var netscape = $.browser.netscape();  // Netscape
    var opera = $.browser.opera();     // Opera
    var safari = $.browser.safari();    // Safari


    var userbrowser = $.browser.browser(); //detected user browser


    //operating systems

    var linux = $.browser.linux(); // Linux
    var mac = $.browser.mac();   // Mac OS
    var win = $.browser.win();   // Microsoft Windows

    //version

    var userversion = $.browser.version.number();

    /* ----------------------------------------------------------------- */

    if (mac == true) {

        $("body").addClass("mac");


    } else if (linux == true) {

        $("body").addClass("linux");

    } else if (win == true) {

        $("body").addClass("windows");

    }


    /* ----------------------------------------------------------------- */

    //iphone|ipod|ipad

    var deviceAgent = navigator.userAgent.toLowerCase();
    // var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);

    if (deviceAgent.match(/iphone/)) {
        $("body").addClass("iphone");
    } else if (deviceAgent.match(/ipod/)) {
        $("body").addClass("ipod");
    } else if (deviceAgent.match(/ipad/)) {
        $("body").addClass("ipad");
    }


    /* ----------------------------------------------------- */

    //IE|Edge|Chrome

    var sBrowser, sUsrAg = navigator.userAgent;

    if (sUsrAg.indexOf("Trident") > -1) {
        $("body").addClass("ie");
    } else if (sUsrAg.indexOf("Edge") > -1) {
        $("body").addClass("edge");
    } else if (sUsrAg.indexOf("Chrome") > -1) {
        $("body").addClass("chrome");
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
        $("body").addClass("opera");
    }


    /* ----------------------------------------------------------------- */

    //Browser

    if (userbrowser == "Safari") {

        $("body").addClass("safari");

    } else if (userbrowser == "Firefox") {

        $("body").addClass("firefox");

    } else if (userbrowser == "Camino") {

        $("body").addClass("camino");

    } else if (userbrowser == "AOL Explorer") {

        $("body").addClass("aol");

    } else if (userbrowser == "Flock") {

        $("body").addClass("flock");

    } else if (userbrowser == "iCab") {

        $("body").addClass("icab");

    } else if (userbrowser == "Konqueror") {

        $("body").addClass("konqueror");

    } else if (userbrowser == "Netscape") {

        $("body").addClass("netscape");

    } else {
    }

    $("body").addClass("" + userversion + "");

    $("body").addClass("version-" + userversion + "");

}


// WEBPACK FOOTER //
// ./src/js/entry.es6